import { render, staticRenderFns } from "./toupkj_config.vue?vue&type=template&id=57f564af&scoped=true&"
import script from "./toupkj_config.vue?vue&type=script&lang=js&"
export * from "./toupkj_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f564af",
  null
  
)

export default component.exports